export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11937.3d764308.jpg";